import { render, staticRenderFns } from "./Vuetable.vue?vue&type=template&id=30bdceb8&scoped=true"
import script from "./Vuetable.vue?vue&type=script&lang=js"
export * from "./Vuetable.vue?vue&type=script&lang=js"
import style0 from "./Vuetable.vue?vue&type=style&index=0&id=30bdceb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bdceb8",
  null
  
)

export default component.exports